import { render, staticRenderFns } from "./tabCharges.vue?vue&type=template&id=4606b820&"
import script from "./tabCharges.vue?vue&type=script&lang=js&"
export * from "./tabCharges.vue?vue&type=script&lang=js&"
import style0 from "./tabCharges.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4606b820')) {
      api.createRecord('4606b820', component.options)
    } else {
      api.reload('4606b820', component.options)
    }
    module.hot.accept("./tabCharges.vue?vue&type=template&id=4606b820&", function () {
      api.rerender('4606b820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabCharges.vue"
export default component.exports